import React, { memo } from "react";
import { Link } from "react-router-dom";
import { CiYoutube } from "react-icons/ci";
import { PiCaretRightBold } from 'react-icons/pi';
const PageTitleSection = (props) => {
    return (
        <>
            {/* <!-- Page Title Section Start --> */}
            <div className="page-title-section section" data-bg-color="#000" aria-label={props.pagetitle} >
                <div className="page-title">
                    <div className="container section-title">
                        <h6 className="title">{props.title}</h6>
                        <p className="text-white sub-title">
                            {props.subtitle}
                        </p>
                    </div>
                </div>
            </div>
            {/* <!-- Page Title Section End --> */}
        </>
    )
}

export default memo(PageTitleSection);